import { render, staticRenderFns } from "./BasicConfiguration.vue?vue&type=template&id=dfa647ca"
import script from "./BasicConfiguration.vue?vue&type=script&lang=js"
export * from "./BasicConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports